import cn from "classnames";
import { bidStatusesEnum } from "helpers/enums";
import { paths } from "helpers/paths";
import { ymEvent } from "helpers/system";
import policy from "policies";
import React from "react";
import CarLocationMap from "./carLocationMap";
import CounterpartiesInRegion from "./counterpartiesInRegion";

const CarDropd = (props) => {
    const { roles, item, row, modal, history, refreshData, bidSelected, organization } = props;

    const newBidAction = () => {
        window.open(`${paths.bidNew}?carId=${item.carId}&backPath=planning`, "_blank");
    };
    const showBidAction = () => {
        window.open(`${paths.bidShow("bid", item.bidId)}?from=planning`, "_blank");
    };
    const filterByCarAction = () => {
        window.open(`${paths.bid}?carId=${item.carId}`, "_blank");
    };
    const showSuitableDistributionBids = () => {
        const carInfo = { ...item, city: row?.original?.city, state: row?.original?.state };
        modal({
            name: "suitableDistributionBids",
            title: "Список подходящих заказов",
            windowMod: "wide",
            history,
            carInfo,
        });
    };
    const editCommentAction = () => {
        modal({
            name: "planningCommentForm",
            title: "Редактирование комментария",
            windowMod: "wide",
            carId: item.carId,
            planningComment: item.carPlanningComment.comment,
            callback: refreshData,
        });
    };
    const newCommentAction = () => {
        modal({
            name: "planningCommentForm",
            title: "Создание комментария",
            windowMod: "wide",
            planningComment: "",
            carId: item.carId,
            callback: refreshData,
        });
    };
    const lockAction = () => {
        modal({
            name: "bookingCommentForm",
            title: "Бронирование машины",
            windowMod: "wide",
            bookingComment: "",
            carId: item.carId,
            callback: refreshData,
        });
    };
    const unlockAction = () => {
        modal({
            name: "bookingCommentForm",
            title: "Бронирование машины",
            windowMod: "wide",
            bookingComment: item.bookingComment,
            carId: item.carId,
            callback: refreshData,
        });
    };

    const showCarLocation = () => {
        modal({
            name: "infoModal",
            title: (
                <span>
                    Текущее местоположение машины <b>{item.number}</b>
                </span>
            ),
            body: (
                <div className="vh-100">
                    <CarLocationMap carLocation={item.carLocation} />
                </div>
            ),
            windowMod: "wide",
        });
    };

    const showCounterpartiesInRegion = () => {
        ymEvent("CounterpartiesInRegionListViewed");
        ymEvent("CounterpartyListinRegionOpened");
        modal({
            name: "default",
            title: "Список контрагентов в регионе прибытия",
            windowMod: "wide",
            CustomBody: CounterpartiesInRegion,
            bodyData: {
                regionId: item.regionId,
                regionType: item.regionType,
                enums: props.enums,
                organization: props.organization,
            },
        });
    };

    const canSetBidEstimatedLeaveDate = () => {
        const { Done, Started } = bidStatusesEnum;
        const { hasBid } = item;
        const { isTruckingOrganizationAdmin, isTruckingOrganizationManager, isTruckingOrganizationHeadLogist } = roles;
        return (
            hasBid &&
            (isTruckingOrganizationAdmin || isTruckingOrganizationManager || isTruckingOrganizationHeadLogist) &&
            [Started, Done].includes(item.bidStatus)
        );
    };

    const setEstimatedLeaveDate = () => {
        const {
            bidId,
            manualEstimatedLeaveDate,
            lastPointPlanEnterDateOffset,
            activeBidLastPointAddress,
            estimationComment,
        } = item;
        const address = row ? `${row.original.state}, ${row.original.city}` : activeBidLastPointAddress;
        return modal({
            name: "setBidEstimatedLeaveDate",
            title: "Изменить расчетное время выезда",
            windowMod: "sm",
            refreshData: () => undefined,
            bidPoint: {
                planEnterDateOffset: lastPointPlanEnterDateOffset,
                geozone: { address },
            },
            manualEstimatedLeaveDate,
            comment: estimationComment,
            bid: { id: bidId },
        });
    };

    return (
        <ul
            className={cn("c-dropd__list c-dropd__list--left c-dropd__list--wide no-bullet", {
                "c-dropd__list--uncontrolled": props.uncontrolled,
            })}
        >
            {!policy("user", { user: { roles } }).isReadOnlyTruckingOrganizationUser() &&
                !organization.distributedBidRequired && (
                <li className="c-dropd__list-item" onClick={newBidAction}>
                    Создать заявку для машины
                </li>
            )}
            {!item.withoutBidPeriod && (
                <li className="c-dropd__list-item" onClick={showBidAction}>
                    {bidSelected ? "Открыть выбранную заявку" : "Открыть активную заявку"}
                </li>
            )}
            <li className="c-dropd__list-item" onClick={filterByCarAction}>
                Открыть список заявок по машине
            </li>
            {(item.withoutBidPeriod || !item.hasPlannedBid) && (
                <li className="c-dropd__list-item" onClick={showSuitableDistributionBids}>
                    Открыть список подходящих заказов
                </li>
            )}
            {item.carLocation && (
                <li className="c-dropd__list-item" onClick={showCarLocation}>
                    Показать машину на карте
                </li>
            )}
            {!item.carPlanningComment && !policy("user", { user: { roles } }).isReadOnlyTruckingOrganizationUser() && (
                <li className="c-dropd__list-item" onClick={newCommentAction}>
                    Добавить комментарий
                </li>
            )}
            {item.carPlanningComment && !policy("user", { user: { roles } }).isReadOnlyTruckingOrganizationUser() && (
                <li className="c-dropd__list-item" onClick={editCommentAction}>
                    Изменить комментарий
                </li>
            )}
            {!item.bookingComment && !policy("user", { user: { roles } }).isReadOnlyTruckingOrganizationUser() && (
                <li className="c-dropd__list-item" onClick={lockAction}>
                    Забронировать машину
                </li>
            )}
            {item.bookingComment && !policy("user", { user: { roles } }).isReadOnlyTruckingOrganizationUser() && (
                <li className="c-dropd__list-item" onClick={unlockAction}>
                    Изменить бронь машины
                </li>
            )}
            {item.regionId && item.regionType && (
                <li className="c-dropd__list-item" onClick={showCounterpartiesInRegion}>
                    Список контрагентов в регионе прибытия
                </li>
            )}
            {canSetBidEstimatedLeaveDate() && (
                <li className="c-dropd__list-item" onClick={setEstimatedLeaveDate}>
                    Редактировать расчетное время выезда
                </li>
            )}
        </ul>
    );
};

export default CarDropd;
